import { BaseQueryApi } from '@reduxjs/toolkit/dist/query'
import { config } from '@config/config'
import { AppState } from '@redux/store'
import { hasCognitoSession } from '@utils/authToken'

const IGNORE_CONTENT_TYPE_ENDPOINTS = ['uploadFile']

const IGNORE_AUTH_ENDPOINTS = ['uploadFile', 'getPrescriptionFileBlob', 'getAttachmentBlob', 'getAttachmentBlobUrl']

const IGNORE_CUSTOMER_HEADER_ENDPOINTS = ['getInsurers', 'getInsurerDetails', 'getInsuranceProvider', 'getDefaultForms']

const APIKEY_ENDPOINTS = ['getAuthToken', 'getInsurersPublic', 'getInsuranceFormAttachmentUrl']

const isSkipContentType = (endpoint: string): boolean => IGNORE_CONTENT_TYPE_ENDPOINTS.includes(endpoint)

const isPublic = (endpoint: string): boolean => {
  return APIKEY_ENDPOINTS.includes(endpoint)
}

const isRequireAuth = (endpoint: string): boolean => {
  return !IGNORE_AUTH_ENDPOINTS.includes(endpoint)
}

const isRequireCustomerHeader = (endpoint: string): boolean => {
  return !endpoint.endsWith('Configuration') && !IGNORE_CUSTOMER_HEADER_ENDPOINTS.includes(endpoint)
}

type PrepareHeadersAPI = Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>

export const dbPrepareHeaders = (headers: Headers, api: PrepareHeadersAPI) => {
  const { getState, endpoint } = api
  const state = getState() as AppState
  const token = state.connector.authToken
  const customer = state.connector.customer

  if (!isSkipContentType(endpoint)) {
    headers.set('Content-Type', 'application/json')
  }

  if (isPublic(endpoint)) {
    headers.set('x-api-key', `${config.getApiKey(endpoint)}`)
  } else if (isRequireAuth(endpoint)) {
    if (token && hasCognitoSession(token)) {
      headers.set('Authorization', `Bearer ${token.accessToken}`)
    }

    if (customer && isRequireCustomerHeader(endpoint)) {
      customer.id && headers.set('x-directbilling-customer-number', customer.id)
      customer.email && headers.set('x-directbilling-customer-email', customer.email)
    }
  }

  return headers
}
